















import { Component, Vue } from "vue-property-decorator";
import { otherUserInfo } from "@/req/user";
import headerBox from "./header.vue";
import infomation from "./information.vue";
@Component({
  components: {
    infomation,
    headerBox
  }
})
export default class Logout extends Vue {
  public info: any = {};
  public uid: any = "1";
  public mounted() {
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    }
    this.getInfo();
  }
  public async getInfo() {
    const res = await otherUserInfo({ uid: this.uid });
    if (res.code == 200) {
      this.info = res.data;
    }
  }
  public getRouter() {
    this.$router.push("/home")
  }
}
